<div class="page">
  <app-page-header page-title="communications.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'communications.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>

          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canReadCommunicationsList')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="createdAt"
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="attachments">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'communications.fields.attachments' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-icon [ngClass]="{ 'd-none': !element.attachments || element.attachments.length === 0 }"
                      fontSet="far" fontIcon="fa-paperclip"></mat-icon>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="attachmentsFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="true">{{ 'common.words.yes' | translate }}</mat-option>
                        <mat-option value="false">{{ 'common.words.no' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(attachmentsFilter)"
                        class="reset-input-icon" *ngIf="attachmentsFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="subject">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'communications.fields.subject' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.subject }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="subjectFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(subjectFilter)"
                        class="reset-input-icon" *ngIf="subjectFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'communications.fields.recipients_long' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                      <mat-chip (click)="element.recipients[0].selected = !element.recipients[0].selected"
                        color="accent"
                        [selected]="element.recipients[0].selected" class="mat-chip-sm">
                        {{ element.recipients[0].email }}
                      </mat-chip>
                      <!-- <mat-chip (click)="element.recipients[0].selected = !element.recipients[0].selected"
                        (selectionChange)="onClickRecipientFiltering(element.recipients[0])"color="accent"
                        [selected]="element.recipients[0].selected" class="mat-chip-sm">
                        {{ element.recipients[0].email }}
                      </mat-chip> -->
                      <span *ngIf="element.recipients.length > 1"> e altri {{ element.recipients.length - 1 }}...</span>
                    <!-- <mat-chip-list *ngFor="let recipient of element.recipients">
                      <mat-chip (click)="recipient.selected = !recipient.selected"
                        (selectionChange)="onClickRecipientFiltering(recipient)" color="accent"
                        [selected]="recipient.selected" class="mat-chip-sm">
                        {{ recipient.email }}
                      </mat-chip>
                    </mat-chip-list> -->
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="emailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(emailFilter)"
                        class="reset-input-icon" *ngIf="emailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.words.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <!-- <button (click)="onViewCommunicationDetail(element)" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-long-arrow-right"></mat-icon>
                    </button> -->
                    <button (click)="onViewCommunicationDetail(element)" mat-icon-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      <mat-icon fontSet="fas" fontIcon="fa-external-link"></mat-icon>
                    </button>
                    <button (click)="onRemoveCommunication(element)" mat-icon-button color="warn"
                      matTooltip="{{ 'communications.list.removeTooltip' | translate }}">
                      <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->